/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DashboardAbsenceIdsDto
 */
export interface DashboardAbsenceIdsDto {
    /**
     * 
     * @type {number}
     * @memberof DashboardAbsenceIdsDto
     */
    idapprenant?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardAbsenceIdsDto
     */
    anneeScolaire?: string | null;
}

/**
 * Check if a given object implements the DashboardAbsenceIdsDto interface.
 */
export function instanceOfDashboardAbsenceIdsDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DashboardAbsenceIdsDtoFromJSON(json: any): DashboardAbsenceIdsDto {
    return DashboardAbsenceIdsDtoFromJSONTyped(json, false);
}

export function DashboardAbsenceIdsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardAbsenceIdsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idapprenant': !exists(json, 'idapprenant') ? undefined : json['idapprenant'],
        'anneeScolaire': !exists(json, 'anneeScolaire') ? undefined : json['anneeScolaire'],
    };
}

export function DashboardAbsenceIdsDtoToJSON(value?: DashboardAbsenceIdsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idapprenant': value.idapprenant,
        'anneeScolaire': value.anneeScolaire,
    };
}

